<template>
  <OwnPopover
    align-y="bottom"
    align-x="left"
    trigger-type="hover"
    content-offset="0"
    :content-width="contentWidth"
    :slide="['x']"
  >
    <template #trigger="{ on }">
      <button v-on="on">
        <slot name="trigger" />
      </button>
    </template>
    <template #content>
      <OwnCard class="info-popover__content" control>
        <slot name="content" />
      </OwnCard>
    </template>
  </OwnPopover>
</template>

<script lang="ts" setup>
import { OwnCard } from '@/ui/OwnCard'
import { OwnPopover } from '@/ui/OwnPopover'

defineProps<{
  contentWidth?: number | string
}>()
</script>

<style lang="scss" scoped>
.info-popover {
  &__content {
    padding: 12px;
  }
}
</style>
